<template>
  <div
    class="question-head"
    :class="isChild ? 'question-head-inner' : ''"
    @click.stop="click"
  >
    <div v-if="!sticky" class="toggle-wrapper">
      <div class="question-toggle"></div>
    </div>
    <div class="title-wrapper">
      <div
        v-if="isChild"
        class="question-title"
        :class="isChild ? 'question-title-inner' : ''"
      >
        {{ inner }}
      </div>
      <div v-else class="question-title">{{ title }}</div>

      <div v-if="subtitle && !isChild" class="question-sub-title">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FaqItemHeader",
  props: ["title", "subtitle", "isChild", "inner", "active", "sticky"],
  emits: ["is-active"],
  data() {
    return {};
  },
  methods: {
    click(e) {
      if (this.sticky) {
        return;
      }

      this.$emit("is-active", this.active);
    },
  },
};
</script>

<style>
. {
}
</style>
